import {InjectionToken} from '@angular/core';


export const GA_TRACKING_ID = new InjectionToken<string>('analytics.tracking_id');
